import styled from 'styled-components'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${props => props.theme.spacing.sp24};
`

export const ButtonsContainer = styled.div`
  display: flex;
  gap: ${props => props.theme.spacing.sp16};
`
